export default __webpack_public_path__ + "static/media/skin-in-the-game-banner.d8503c29.jpg";